module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.localSetting && _vm.localSetting.db) ? _c('div', {
    class: 'setting ' + (this.loading ? ' setting--loading' : '') + (!_vm.localSetting.db.in_use ? ' setting--not-in-use' : '') + (!_vm.localSetting.can_edit ? ' setting--disabled' : '')
  }, [_c('div', {
    staticClass: "setting__title"
  }, [(_vm.localSetting.raw && _vm.localSetting.raw.season && _vm.localSetting.raw.season === 'summer') ? _c('img', {
    staticClass: "setting__icon",
    attrs: {
      "src": "https://www.branas.se/app/themes/branasgruppen-core/assets/images/weather/sun.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.localSetting.raw && _vm.localSetting.raw.season && _vm.localSetting.raw.season === 'winter') ? _c('img', {
    staticClass: "setting__icon",
    attrs: {
      "src": "https://www.branas.se/app/themes/branasgruppen-core/assets/images/icons/snowflake-icon.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "setting__active"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSetting.db.in_use),
      expression: "localSetting.db.in_use"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localSetting.db.in_use) ? _vm._i(_vm.localSetting.db.in_use, null) > -1 : (_vm.localSetting.db.in_use)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.localSetting.db.in_use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localSetting.db, "in_use", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localSetting.db, "in_use", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localSetting.db, "in_use", $$c)
        }
      }, function($event) {
        return _vm.updateSetting(_vm.localSetting.db)
      }]
    }
  })]), _vm._v("\n\n      " + _vm._s(_vm.localSetting.title || _vm.localSetting.db.key) + "\n\n      "), _c('div', {
    staticClass: "setting__description"
  }, [(_vm.localSetting.db.description) ? _c('div', [_vm._v(_vm._s(_vm.localSetting.db.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "setting__details"
  }, [_c('div', [_vm._v("Tillåter HTML: "), _c('span', [_vm._v(_vm._s(_vm.localSetting.html ? '✓' : '⨉'))])]), _vm._v(" "), (_vm.localSetting.db.example) ? _c('div', [_vm._v("Exempel: "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localSetting.db.example)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.localSetting.db.default_value) ? _c('div', [_vm._v("Standard: " + _vm._s(_vm.localSetting.db.default_value))]) : _vm._e(), _vm._v(" "), (_vm.localSetting.db.updated_at) ? _c('div', [_vm._v("Senast ändrad: " + _vm._s(_vm._f("fromNow")(_vm.localSetting.db.updated_at)))]) : _vm._e()])]), _vm._v(" "), (_vm.localSetting.db.in_use) ? _c('div', {
    class: 'setting__editor setting__editor--' + (_vm.localSetting.db.key.replace('.', '-'))
  }, [(_vm.setting.editor === 'boolean') ? _c('div', [_c('div', {
    staticStyle: {
      "width": "105px"
    }
  }, [_c('SwitchButton', {
    attrs: {
      "store": _vm.localSetting.db.key,
      "iconscale": 2,
      "value": _vm.localSetting.db.value,
      "sync": false,
      "labels": {
        checked: 'Ja',
        unchecked: 'Nej'
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  })], 1)]) : (_vm.setting.editor === 'date') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSetting.db.value),
      expression: "localSetting.db.value"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.localSetting.db.value)
    },
    on: {
      "change": function($event) {
        return _vm.updateSetting(_vm.localSetting.db)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localSetting.db, "value", $event.target.value)
      }
    }
  })]) : (_vm.setting.editor === 'tablelist') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.75rem",
      "display": "flex",
      "gap": "0.5rem",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, [(!_vm.sortingEnabled && _vm.localSetting.db.value.length > 2 && _vm.localSetting.edit_settings.sortable) ? _c('button', {
    staticClass: "button small white border",
    staticStyle: {
      "padding": "4px 10px",
      "font-size": "0.85em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enableSorting($event)
      }
    }
  }, [_vm._v(_vm._s('Ändra ordning'))]) : _vm._e(), _vm._v(" "), (_vm.sortingEnabled) ? _c('button', {
    staticClass: "small green",
    staticStyle: {
      "padding": "4px 10px",
      "font-size": "0.85em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveSorting($event)
      }
    }
  }, [_vm._v(_vm._s('Spara'))]) : _vm._e(), _vm._v(" "), (_vm.sortingEnabled) ? _c('button', {
    staticClass: "small border",
    staticStyle: {
      "padding": "4px 10px",
      "font-size": "0.85em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelSorting($event)
      }
    }
  }, [_vm._v(_vm._s('Avbryt'))]) : _vm._e()]), _vm._v(" "), _c('table', {
    class: 'multi-value-table multi-value-table--' + _vm.localSetting.edit_settings.columns + (_vm.sortingEnabled ? ' sorting-active' : '')
  }, [_c('tbody', _vm._l((_vm.localSetting.db.value), function(row, rowIndex) {
    return _c('tr', {
      key: _vm.localSetting.db.key + '-' + rowIndex,
      class: (rowIndex === _vm.localSetting.db.value.length - 1 ? 'multi-value-table--last' : '') + (_vm.sortingEnabled ? ' draggable-row' : '') + (_vm.sortingEnabled && _vm.dragOverIndex === rowIndex ? ' drag-over' : ''),
      attrs: {
        "draggable": _vm.sortingEnabled && rowIndex < _vm.localSetting.db.value.length - 1
      },
      on: {
        "dragstart": function($event) {
          return _vm.dragStart($event, rowIndex)
        },
        "dragenter": function($event) {
          return _vm.dragEnter(rowIndex)
        },
        "dragend": _vm.dragEnd,
        "dragover": function($event) {
          $event.preventDefault();
        },
        "drop": function($event) {
          return _vm.dropRow($event, rowIndex)
        }
      }
    }, [_vm._l((row), function(col, colIndex) {
      return _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.localSetting.edit_settings.column_types || _vm.localSetting.edit_settings.column_types[colIndex] !== 'hidden'),
          expression: "!localSetting.edit_settings.column_types || localSetting.edit_settings.column_types[colIndex] !== 'hidden'"
        }],
        key: colIndex
      }, [(_vm.localSetting.edit_settings.column_types && _vm.localSetting.edit_settings.column_types[colIndex] === 'singleline') ? _c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localSetting.db.value[rowIndex][colIndex]),
          expression: "localSetting.db.value[rowIndex][colIndex]"
        }],
        attrs: {
          "type": "text",
          "disabled": _vm.sortingEnabled,
          "placeholder": _vm.localSetting.edit_settings.column_help && _vm.localSetting.edit_settings.column_help[colIndex] || 'Värde'
        },
        domProps: {
          "value": (_vm.localSetting.db.value[rowIndex][colIndex])
        },
        on: {
          "change": function($event) {
            return _vm.updateSetting(_vm.localSetting.db)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.localSetting.db.value[rowIndex], colIndex, $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.localSetting.edit_settings.column_types && _vm.localSetting.edit_settings.column_types[colIndex] === 'id') ? _c('div', [_vm._v("\n                  #" + _vm._s(_vm.localSetting.db.value[rowIndex][colIndex]) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.localSetting.edit_settings.column_types && _vm.localSetting.edit_settings.column_types[colIndex] === 'text') ? _c('div', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localSetting.db.value[rowIndex][colIndex]),
          expression: "localSetting.db.value[rowIndex][colIndex]"
        }],
        attrs: {
          "disabled": _vm.sortingEnabled,
          "placeholder": _vm.localSetting.edit_settings.column_help && _vm.localSetting.edit_settings.column_help[colIndex] || 'Värde'
        },
        domProps: {
          "value": (_vm.localSetting.db.value[rowIndex][colIndex])
        },
        on: {
          "change": function($event) {
            return _vm.updateSetting(_vm.localSetting.db)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.localSetting.db.value[rowIndex], colIndex, $event.target.value)
          }
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('td', {
      staticClass: "multi-value-table--counter"
    }, [(_vm.sortingEnabled && rowIndex < _vm.localSetting.db.value.length - 1) ? _c('span', {
      staticStyle: {
        "font-size": "1.1em",
        "cursor": "grab"
      }
    }, [_vm._v("☰")]) : (rowIndex === _vm.localSetting.db.value.length - 1) ? _c('span', [_vm._v("Ny")]) : _vm._e()])], 2)
  }), 0)])]) : (_vm.setting.editor === 'translator') ? _c('div', [_c('table', {
    class: 'multi-value-table multi-value-table--' + _vm.SITE_CONFIG.languages.full.length
  }, [_c('tbody', [_c('tr', _vm._l((_vm.SITE_CONFIG.languages.full), function(lang, langIndex) {
    return _c('td', {
      key: langIndex
    }, [_c('label', [_c('img', {
      attrs: {
        "src": 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + lang.flag + '.svg',
        "width": "12"
      }
    }), _vm._v("\n                  " + _vm._s(lang.title) + "\n                ")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localSetting.db.value[lang.value]),
        expression: "localSetting.db.value[lang.value]"
      }],
      domProps: {
        "value": (_vm.localSetting.db.value[lang.value])
      },
      on: {
        "change": function($event) {
          return _vm.updateSetting(_vm.localSetting.db)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.localSetting.db.value, lang.value, $event.target.value)
        }
      }
    })])
  }), 0)])])]) : _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSetting.db.value),
      expression: "localSetting.db.value"
    }],
    attrs: {
      "placeholder": "Värde"
    },
    domProps: {
      "value": (_vm.localSetting.db.value)
    },
    on: {
      "change": function($event) {
        return _vm.updateSetting(_vm.localSetting.db)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localSetting.db, "value", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.setting.editor === 'image') ? _c('div', {
    staticClass: "image-preview"
  }, [_c('a', {
    attrs: {
      "href": _vm.localSetting.db.value,
      "target": "_blank"
    }
  }, [(_vm.localSetting.db.value) ? _c('img', {
    attrs: {
      "src": _vm.localSetting.db.value
    }
  }) : _vm._e()])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b521bebe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Setting.vue
// module id = 1034
// module chunks = 0